import React from 'react';
import {useTranslation} from 'react-i18next';
import {goBack} from '@utils';
import {ReactComponent as LeftArrow} from './assets/left-arrow.svg';
import RulesContent from '@/pages/agent/rules-content';
import './agent-page.css';

const AgentPage = () => {
  const {i18n} = useTranslation();

  const handleBack = () => {
    // 返回到 EarnMoney Tab 的 invitation-reward 标签
    goBack();
  };

  return (
    <div className="flex flex-col w-[23.4375rem] h-full fixed top-0 left-1/2 -translate-x-1/2 bg-bg">
      <div className="flex flex-row items-center h-11 bg-white">
        <LeftArrow className="goback-arrow ml-2" onClick={handleBack} />
        <h1 className="nav-title">{i18n.t('proxy.agent-rules')}</h1>
      </div>
      <RulesContent />
    </div>
  );
};

export default AgentPage;
